<template>
  <Menu as="div" class="relative inline-block text-left" v-slot="{ open }">
    <div>
      <MenuButton
        class="
          inline-flex
          justify-center
          w-full
          px-4
          py-2
          rounded-md
          border-2
          hover:border-brand-mid-gray
        "
        :class="[
          open
            ? 'border-2 border-brand-mid-gray bg-brand-light-gray'
            : 'border-2 border-transparent'
        ]"
      >
        <div class="flex">
          <p :class="[open ? 'text-brand-green' : '']">View More</p>
          <div class="flex items-center ml-2">
            <ChevronDownIcon class="w-6 h-6 text-brand-green" v-if="!open" />
            <ChevronUpIcon class="w-6 h-6 text-brand-green" v-if="open" />
          </div>
        </div>
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="
          absolute
          right-0
          w-56
          mt-2
          origin-top-right
          bg-white
          divide-y-2 divide-brand-background-light-blue
          rounded-md
          shadow-lg
          ring-1 ring-black ring-opacity-5
          focus:outline-none
          z-10
          border-2 border-brand-gray
        "
      >
        <MenuItem v-slot="{ active }">
          <router-link
            tag="div"
            :to="{ name: 'apply_sample' }"
            class="flex rounded-t items-center py-2 px-2"
            :class="[active ? 'bg-brand-light-gray' : 'bg-white']"
          >
            <p :class="[active ? 'text-brand-green' : '']">
              Interactive application
            </p>
          </router-link>
        </MenuItem>
        <MenuItem v-slot="{ active }">
          <router-link
            tag="div"
            :to="{ name: 'home_demo' }"
            class="flex rounded-b items-center py-2 px-2"
            :class="[active ? 'bg-brand-light-gray' : 'bg-white']"
          >
            <p :class="[active ? 'text-brand-green' : '']">Sample reports</p>
          </router-link>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue"
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/vue/solid"

export default {
  components: {
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    ChevronDownIcon,
    ChevronUpIcon
  }
}
</script>
